import React from 'react';
import { partNumber as defaultTooltip } from 'pu-data/Tooltips';
import TextComponent from './TextComponent';

const PartNumber = (props) => {
  const name = 'part_number';

  const {
    label, inputId, required, groupName, children, onChangeParameter, errorMessage, tooltip,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);
  const { parameters } = props
  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      value={parameters[name] || ''}
      required={required}
      onChange={onChange}
      tooltip={tooltip}
      ignoreOnQuote
      groupName={groupName}
      errorMessage={errorMessage}>
      {children}
    </TextComponent>
  );
};

PartNumber.defaultProps = {
  required: true,
  inputId: 'part-number',
  label: 'Part<br class="d-none d-lg-block d-xl-none" /> Number',
  tooltip: defaultTooltip,
};

export default PartNumber;
